'use client';

import { usePathname } from 'next/navigation';
import RequestQuoteHeader from '../RequestQuoteHeader';
import RequestQuoteFooter from '../RequestQuoteFooter/RequestQuoteFooter';
import Header from '../Header';
import Footer from '../Footer/Footer';
import CookiesModal from '../CookiesModal/CookiesModal';
import AircraftIncidentModal from '../AircraftIncidentModal/AircraftIncidentModal';
import PromotionAnnouncementBanner from '../PromotionAnnouncementBanner/PromotionAnnouncementBanner';
// TODO: restore on January 1, 2027 and comment out PromotionAnnouncementBanner
// import AnnouncementBanner from '../AnnouncementBanner/AnnouncementBanner';

export default function MainProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const aircraftIncident = false;
  const pathname = usePathname();
  const isMinimalChromePage =
    pathname === '/request-a-quote' || pathname === '/instant-estimate';
  return (
    <>
      {isMinimalChromePage ? (
        <>
          <RequestQuoteHeader />
          {children}
          <RequestQuoteFooter />
        </>
      ) : (
        <>
          {/* <AnnouncementBanner /> */}
          <PromotionAnnouncementBanner />
          <Header />
          {children}
          <CookiesModal />
          {aircraftIncident && <AircraftIncidentModal />}
          <Footer />
        </>
      )}
    </>
  );
}
